import { UI, NextPagePropertiesModel } from '@cvx/nextpage-typescript'
import { NextPageOptionsModel } from '../models/nextpage-options.model'

export class NextPageService {
  public options: NextPageOptionsModel
  public properties: NextPagePropertiesModel
  public UI: UI
  public events: Record<string, Function>

  constructor() {
    this.options = new NextPageOptionsModel()
    this.properties = new NextPagePropertiesModel()
    this.UI = new UI(this.options, false)
  }

  registerReactEvent = (eventKey: string, eventFunction: Function): void => {
    this.events[eventKey] = eventFunction;
    this.UI.events[eventKey] = eventFunction;
  }
}

export default NextPageService
